import { ComponentStylesWithFns } from '../../theme/styles.helpers';

export const TemplateStyles: ComponentStylesWithFns = {
  root: {
    // The editor owns the viewport: the page itself never scrolls, each column does.
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',

    '& > form': {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      minHeight: 0,
    },

    '.Products-heading': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '5px',
      height: '112px',
      flexShrink: 0,
      marginX: 'auto',
      width: '90%',

      '.Buttons': {
        display: 'flex',
        gap: '5px',
      },
    },

    '.Form-form': {
      display: 'flex',
      gap: '16px',
      marginX: 'auto',
      width: '90%',
      flexGrow: 1,
      // Without this the columns' content sets the height and the page scrolls.
      minHeight: 0,
      paddingBottom: '16px',
      boxSizing: 'border-box',
    },

    // Both columns share the row height and scroll their own overflow.
    '.Form-column': {
      // flex-basis 0 so the ratio below decides the split, not the content width.
      flexBasis: 0,
      minWidth: 0,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
    },

    // The preview gets three quarters of the row; the step list is the sidebar.
    '.Form-editor': {
      flexGrow: 1,
    },

    '.Form-preview': {
      flexGrow: 3,
      alignItems: 'center',
      overflowY: 'auto',
      // Matches the Shopify page the widget is embedded in, so the preview shows
      // the survey against the background it actually ships on.
      backgroundColor: '#f8f9fc',
      // #f8f9fc sits a hair off the white page, so the fill alone does not show
      // where the preview starts - the outline carries the edge instead.
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: '6px',
    },
  },
};
